import { Icon } from '@mondra/ui-components'
import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../const'

const menuItemClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'menu-items-item menu-items-active' : 'menu-items-item'

const PackagingNav: FC = () => {
  const {
    componentTaxonomy,
    endOfLife,
    materialEmissionFactors,
    materialTaxonomies,
    packagingProcessing,
  } = ROUTES

  return (
    <>
      <NavLink to={materialEmissionFactors} className={menuItemClass}>
        <Icon type="waterPollutionImpact" /> Material Emission Factors
      </NavLink>
      <NavLink to={packagingProcessing} className={menuItemClass}>
        <Icon type="processing" /> Processing Activities
      </NavLink>
      <NavLink to={endOfLife} className={menuItemClass}>
        <Icon type="industry" /> End of Life
      </NavLink>
      <br />
      <hr />
      <h4 className="mb-3 ml-3 mt-5">Taxonomies</h4>
      <NavLink to={materialTaxonomies} className={menuItemClass}>
        <Icon type="ingredients" /> Material Taxonomy
      </NavLink>
      <NavLink to={componentTaxonomy} className={menuItemClass}>
        <Icon type="product" /> Component Taxonomy
      </NavLink>
    </>
  )
}

export default PackagingNav
